import React from 'react'
import styled from '@emotion/styled'
import BasicButton from '../../generic/button'

import { fontSizeMedium, fontSize3XSmall, fontWeightBold, grayLight20 } from '../../../constants/principles'

export default ({ header, subheader, year, make, model, trim, kbbUrl }) => (
  <StepDiv data-testid={`oc-step-start-trade-in-online`}>
    <Header>{header}</Header>
    <Subheader>{subheader}</Subheader>
    <div>
      Your Trade-In: <br /> <BoldSpan>{year + ' ' + make + ' ' + model + ' ' + trim} </BoldSpan>
    </div>
    <BasicButton data-testid={`ti-btn-see-local-dealer`} onClick={() => (window.location.href = `${kbbUrl}/find-trade-in-dealer/`)}>See Local Dealers</BasicButton>
  </StepDiv>
)

const StepDiv = styled.div`
  padding-bottom: 32px;
  text-align: center;
  width: 100%;
  border-bottom: 1px solid ${grayLight20};
`

const BoldSpan = styled.span`
  font-weight: ${fontWeightBold};
`
const Header = styled.div`
  font-size: ${fontSizeMedium};
  font-weight: ${fontWeightBold};
  padding-top: 32px;
`
const Subheader = styled.div`
  font-size: ${fontSize3XSmall};
  padding-bottom: ${p => (p.padding ? p.padding : `16px`)};
`
